'use client';

import { useStore } from '@mui/x-internals/store';
import { chatSelectors } from "../selectors/index.js";
import { useChatStore } from "./useChatStore.js";
export function useConversations() {
  const store = useChatStore();
  return useStore(store, chatSelectors.conversations);
}
export function useConversation(id) {
  const store = useChatStore();
  const conversation = useStore(store, chatSelectors.conversation, id);
  return conversation ?? null;
}